export default {
  data: '/portal/api/oil-samples',
  export: '/portal/api/oil-samples/export',
  reportRoute: '/portal/oil-samples/report',
  reportApi: '/portal/api/oil-samples/report',
  graphRoute: '/portal/oil-samples/graph',
  graphApi: '/portal/api/oil-samples/graph',
  detailPortalRoute: '/portal/oil-samples/detail',
  detailPortalApi: '/portal/api/oil-samples/detail'
};
